import { Segmented } from 'antd';
import { useState } from 'react';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import InviteHqPractitioner from './InvitePractitioner/InvitePractitioner.page';
import TemplateContext from './TemplateContext/TemplateContext.page';
import { usePageHeader } from 'src/hooks/misc';

const OfficePracticum = () => {
  usePageHeader({
    title: 'Office Practicum Settings',
  });
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('officePracticumSegment') || 'Invite Practitioner';
  });

  const superAdminButton = [
    {
      label: 'Invite Practitioner',
      isActive: activeButton === 'Invite Practitioner',
      onClick: () => setActiveButton('Invite Practitioner'),
    },
    {
      label: 'Template Context',
      isActive: activeButton === 'Template Context',
      onClick: () => setActiveButton('Template Context'),
    },
  ];

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    storeInLocal('officePracticumSegment', value);
  };

  return (
    <div className={`page-wrapper`}>
      <div className="lg:flex gap-3 justify-between py-3 items-center ">
        <Segmented
          options={superAdminButton.map((button) => ({
            label: button.label,
            value: button.label,
          }))}
          value={activeButton}
          onChange={(value) => {
            handleSegmentedTabChange(value);
          }}
        />
      </div>
      <div>
        {activeButton === 'Invite Practitioner' && (
          <>
            <InviteHqPractitioner />
          </>
        )}
        {activeButton === 'Template Context' && <TemplateContext />}
      </div>
    </div>
  );
};

export default OfficePracticum;
